'use client';
import { useState } from 'react';
import Link from 'next/link';
import { PlusCircleOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { twMerge } from 'tailwind-merge';
import { COLORS } from '@/common/constants';

export default function SoDo({ menuTree }) {
  const [openItems, setOpenItems] = useState({});
  const [selectedSlug, setSelectedSlug] = useState(null);

  const toggleItem = (id) => {
    setOpenItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleSelect = (slug) => {
    setSelectedSlug(slug);
  };

  // 🧠 Đệ quy render menu + xử lý URL động
  const renderMenu = (items, depth = 0, parentIds = new Set(), rootSlug = null) => {
    return items.map((item) => {
      if (parentIds.has(item.id)) return null;

      const isOpen = openItems[item.id];
      const hasChildren = item.children && item.children.length > 0;
      const newParentIds = new Set(parentIds);
      newParentIds.add(item.id);

      // Tính toán đường dẫn
      const slugPath =
        depth === 0
          ? `/${item.slug}` // cấp 1
          : `/${rootSlug}/${item.slug}`; // cấp 2+

      return (
        <div key={item.id} className={depth === 0 ? 'mb-3' : 'mb-0'}>
          {hasChildren ? (
            <button
              type="button"
              onClick={() => toggleItem(item.id)}
              className={`w-full flex items-center border-[1px] border-[#E2E7ED] rounded-xs justify-between ${
                depth === 0 ? 'bg-[#F3F6FB]' : 'bg-white'
              } hover:bg-gray-200 px-4 py-3 font-medium text-left`}
              style={{ paddingLeft: `${depth * 20 + 16}px` }}>
              <span className="flex items-center gap-2">
                {isOpen ? <MinusCircleOutlined /> : <PlusCircleOutlined />}
                <span>{item.name}</span>
              </span>
            </button>
          ) : (
            <div
              className={`w-full flex items-center border-[1px] border-[#E2E7ED] rounded-xs justify-between ${
                depth === 0 ? 'bg-[#F3F6FB]' : 'bg-white'
              } hover:bg-gray-200 px-4 py-3 font-medium text-left`}
              style={{ paddingLeft: `${depth * 20 + 16}px` }}>
              <Link
                href={slugPath}
                onClick={() => handleSelect(item.slug)}
                className={`hover:underline ${selectedSlug === item.slug ? 'text-blue-700 font-semibold' : ''}`}>
                {item.name}
              </Link>
            </div>
          )}

          {/* Render children nếu có */}
          {hasChildren && isOpen && <div className="border-t">{renderMenu(item.children, depth + 1, newParentIds, rootSlug || item.slug)}</div>}
        </div>
      );
    });
  };

  return (
    <>
      <h1 className={twMerge('text-2xl font-bold mb-3 uppercase', COLORS.primary)}>Sơ đồ trang</h1>
      <div className="overflow-hidden">{renderMenu(menuTree)}</div>
    </>
  );
}
